<template>
    <div class="delete-me">
        <div class="tuk-icon" @click="goHome" />
        <div class="notification" @click="clicked">
            <div class="subtitle">
                TUK App Account Deletion
            </div>
            <p>
                To request account deletion send an email to <a :href="href" target="_blank">deleteme@tukapp.co</a> with
                your account
                number.
            </p>
            <br>
            <p>Your account number is the mobile phone number associated with your TUK App account.</p>
            <br>
            <div v-if="accountNumber">
                <p>You account number is <b>{{ accountNumber }}</b></p>
                <br>
            </div>
            <p>Once we confirm the account number it will be deleted within 5 working days.</p>
            <br>
            <p>Account deletions are irreversible.</p>
            <br>
            <div v-if="isClicked">
                <p class="has-text-link">
                    If your email app doesn't open automatically you can manually send an email with the subject line:
                    <b>{{ emailSubject }}</b>.
                </p>
                <br>
            </div>
            <p class="button is-fullwidth is-danger" @click="emailDeleteMe">Delete This Account</p>
        </div>
        <span class="button is-link has-text-weight-medium" @click="goHome">Back to TUK</span>
    </div>
</template>


<script>
export default {
    name: "DeleteMe",
    components: {
    },
    data() {
        return {
            emailAddress: "deleteme@tukapp.co",
            isClicked: false
        };
    },
    computed: {
        accountNumber() {
            return this.$store.getters.phoneNumber;
        },
        emailSubject() {
            return `DELETE ME [ ${this.accountNumber || 'unknown user'} ]`;
        },
        href() {
            return `mailto:${this.emailAddress}?subject=${this.emailSubject}`;
        }
    },
    mounted() {
    },
    activated() {
    },
    methods: {
        goHome() {
            this.$router.push("/home");
        },
        emailDeleteMe() {
            // this.isClicked = true;
            window.location.href = this.href;
        },
        clicked() {
            this.isClicked = true
            var name = this.$store.getters.realName;
            var msg = `💣 ${this.emailSubject} ${name}`
            this.sendSuperuserNotification(msg);
        }
    },
};
</script>

<style scoped>
.delete-me {
    background-color: #fac002;
    width: 100%;
    height: 100%;
}

.tuk-icon {
    background-image: url("../../public/img/icons/round-512x512.png");
    height: 150px;
    width: 150px;
    background-size: cover;
    margin-left: 20px;
}

.notification {
    margin: 20px;
    margin-top: 0;
    text-align: left;
    max-height: calc(100vh - 225px);
    overflow: scroll;
}
</style>